<ion-content [fullscreen]="true" class="ion-padding sheet">
	<ion-buttons class="close-btn">
		<ion-button (click)="close()" fill="clear">
			<ion-icon name="close"></ion-icon>
		</ion-button>
	</ion-buttons>

	@if (equalSplit) {
		<h2 [innerHTML]="'guestCount.titleEqual' | translate" class="title"></h2>
	} @else {
		<h2 [innerHTML]="'guestCount.titleSeparate' | translate" class="title"></h2>
	}

	<div #scrollContainer class="scroll-container">
		<div class="pad" data-type="pad"></div>

		@for (n of numbers; track n) {
			<div (click)="selectNumber(n)" [class.active]="n === current" class="num">
				{{ n }}
			</div>
		}

		<div class="pad" data-type="pad"></div>
	</div>

	<ion-button (click)="confirmCenter()" class="confirm" expand="block">{{ 'common.confirm' | translate }}</ion-button>
</ion-content>
